module.exports = __webpack_public_path__ + "media/images/select2-00848dcc863ebb3ae64de6baf17e665e.png";